import {
  APPOINTMENT_STATUSES_MAP,
  BOOKING_TYPE_NOT_WORKING,
  BOOKING_TYPE_BREAK,
  BOOKING_TYPE_TIMEOFF,
  BOOKING_TYPE_BUSINESS,
  BOOKING_TYPE_CUSTOMER,
  BOOKING_TYPE_RESERVATION,
  BOOKING_TYPE_APPOINTMENT,
} from '@/lib/consts.ts'

export const LEGACY_EVENT_TYPE = {
  NOT_WORKING: BOOKING_TYPE_NOT_WORKING,
  BREAK: BOOKING_TYPE_BREAK,
  TIMEOFF: BOOKING_TYPE_TIMEOFF,
  BOOKING_BUSINESS: BOOKING_TYPE_BUSINESS,
  BOOKING_CUSTOMER: BOOKING_TYPE_CUSTOMER,
  BOOKING_APPOINTMENT: BOOKING_TYPE_APPOINTMENT,
  TIME_RESERVATION: BOOKING_TYPE_RESERVATION,
} as const

export const FIRESTORE_EVENT_TYPE = {
  CLOSED_HOURS: 'closed_hours',
  TIME_OFF: 'time_off',
  BREAK: 'break',
  BOOKING: 'booking',
  TIME_RESERVATION: 'reservation',
} as const

export type FirestoreEventType = ValueOf<typeof FIRESTORE_EVENT_TYPE>

export const FIRESTORE_WEEKS_RANGE = 7

export const APPOINTMENTS_VISIBLE_ON_CALENDAR = new Set([
  APPOINTMENT_STATUSES_MAP.ACCEPTED,
  APPOINTMENT_STATUSES_MAP.FINISHED,
  APPOINTMENT_STATUSES_MAP.NOSHOW,
  APPOINTMENT_STATUSES_MAP.PROPOSED,
  APPOINTMENT_STATUSES_MAP.PREPAYMENT_AWAITING,
  APPOINTMENT_STATUSES_MAP.UNCONFIRMED,
  APPOINTMENT_STATUSES_MAP.MODIFIED,
])
